<template>
  <sl-table ref="table" :loading="loading" :page="page" :columns="columns" :data="data" @on-selection-change="handleSelect" @on-update="handleChange"></sl-table>
</template>
<script>
import carTrack from '../track/index'

export default {
  data() {
    return {
      columns: [{
          type: 'index',
          width: 60,
          title: '序号',
          align: 'center'
        },
        {
          title: '所属网点',
          key: 'companyName',
          minWidth:150,
        },
        {
          title: '用户',
          key: 'courierName',
          minWidth:150,
        },
        {
          title: '联系方式',
          key: 'courierPhone',
          minWidth:120,
        },
        {
          title: '开始时间',
          key: 'bindDatetimeText',
          minWidth:120,
        },
        {
          title: '结束时间',
          key: 'releaseDatetimeText',
          minWidth:120,
        },
        {
          title: '状态',
          key: 'stateText',
          minWidth:100,
        },
        {
          title: '操作',
          key: 'operation',
          width: 100,
          align: 'center',
          fixed: 'right',
          render:(h , {row}) => {
            return <a on-click={()=>this.viewTrail(row)}>历史轨迹</a>
          }
        }
      ],
      data: [],
      page: {
        pageNum: 1,
        pageSize: 8,
        total: 0
      },
      loading: false
    }
  },

  props: {
    carNo: {
      type: [Number, String]
    }
  },
  created(){
    this.$watch('carNo' , function(val){
      if (val) {
        this.init()
      }
    },{immediate:true})
  },
  methods: {
    init() {
      let params = { search: { carNo: this.carNo }, pageSize: this.page.pageSize, pageNum: this.page.pageNum }
      this.loading = true
      this.$request.carLogs(params).then(resp => {
        this.loading = false
        if (resp.code == 0) {
          this.data = this.$utils.flat(this.$utils.conv(resp.data.list || [], { 'bindDatetime': 'datetime', 'releaseDatetime': 'datetime', 'state': '$carUseState' }))
          this.page.total = resp.data.total || 0
        }
      })
    },
    viewTrail(row) {
      this.$dialog({
        width: 850,
        // transitionNames: ['none', 'none'],
        paddingless: true,
        render: (h) => {
          return h(carTrack, { props: { id: row.carId , limit:[row.bindDatetime , row.releaseDatetime] } })
        }
      })
    },
    handleChange(pageNum, pageSize) {
      if (this.page.pageNum != pageNum || this.page.pageSize != pageSize) {
        this.page.pageNum = pageNum
        this.page.pageSize = pageSize
        this.init()
      }
    },

    handleSelect(selection) {
    }
  }
}

</script>
